import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Calculator, ChevronRight, FileText, Loader2 } from "lucide-react";
import { aktueryaMerkez } from "@/lib/api";

function tl(n) {
    if (n == null) return "—";
    return `₺${Number(n).toLocaleString("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export default function AktueryaDosyaPanel({ dosyaId }) {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!dosyaId) return;
        setLoading(true);
        aktueryaMerkez
            .liste({ dosya_id: dosyaId })
            .then((r) => setItems((r.items || []).slice(0, 3)))
            .catch(() => setItems([]))
            .finally(() => setLoading(false));
    }, [dosyaId]);

    return (
        <div className="rounded-xl border border-white/10 bg-slate-950/40 p-4 mb-4">
            <div className="flex items-center justify-between gap-2 mb-3">
                <div className="flex items-center gap-2">
                    <span className="flex h-8 w-8 items-center justify-center rounded-lg border border-white/10 bg-black/20">
                        <Calculator className="h-4 w-4 text-slate-300" />
                    </span>
                    <div>
                        <div className="font-medium text-sm text-white">Aktüerya</div>
                        <div className="text-[10px] text-slate-500">TRH-2010 · SİG / DYK</div>
                    </div>
                </div>
                <Link
                    to={`/yeni/aktuerya-merkezi?dosya_id=${dosyaId}`}
                    className="inline-flex items-center gap-1 text-xs text-[#D4AF37] hover:underline"
                >
                    Yeni hesap <ChevronRight className="h-3 w-3" />
                </Link>
            </div>
            {loading ? (
                <div className="flex items-center gap-2 text-xs text-slate-500 py-2">
                    <Loader2 className="h-3 w-3 animate-spin" /> Yükleniyor…
                </div>
            ) : items.length === 0 ? (
                <p className="text-xs text-slate-500 leading-relaxed">
                    Bu dosyada aktüerya kaydı yok. Kesin + tahmini band ile hesap başlatın.
                </p>
            ) : (
                <ul className="space-y-2">
                    {items.map((k) => (
                        <li key={k.id} className="flex justify-between gap-2 text-xs border-t border-white/5 pt-2 first:border-0 first:pt-0">
                            <div className="min-w-0">
                                <div className="text-slate-300 truncate">{k.baslik || k.hesap_turu}</div>
                                <div className="text-[10px] text-slate-600 mt-0.5">{k.tarih?.slice(0, 10)}</div>
                            </div>
                            <div className="text-right shrink-0 tabular-nums">
                                <div className="text-emerald-300/90">{tl(k.net_tazminat_kesin ?? k.net_tazminat)}</div>
                                {k.tahmini_aralik ? (
                                    <div className="text-[10px] text-slate-600">{tl(k.tahmini_aralik.min)} – {tl(k.tahmini_aralik.max)}</div>
                                ) : null}
                            </div>
                        </li>
                    ))}
                </ul>
            )}
            {items.length > 0 ? (
                <Link
                    to={`/yeni/aktuerya-merkezi?dosya_id=${dosyaId}`}
                    className="mt-3 inline-flex items-center gap-1 text-[10px] text-slate-500 hover:text-slate-300"
                >
                    <FileText className="h-3 w-3" /> Tüm kayıtları gör
                </Link>
            ) : null}
        </div>
    );
}
